import axiosApi from '../../utilities/axiosApi';

export function createLead(data) {
    let requestUrl = 'api/deduplication/accounts/anonymous';
    return axiosApi.post(requestUrl, data).then(response => {
        return response;
    }).catch(error => {
        throw error;
    });
}